import React from 'react';

import { Section } from '@gogame/components';

export const LinkFormatSection = ({ linkFormat }) => {
  return <Section title={'Link format'}>{linkFormat}</Section>;
};
